module.exports = __webpack_public_path__ + "static/media/1.d6c1887d.jpg";